<script>
  let {
    assetsPath = '/',
    onAiMounted = () => {},
    onArtboardChange = () => {},
  } = $props();
  import { onMount, untrack } from 'svelte';
  let aiBox;
  let aiBoxWidth = $state(undefined);
  let allArtboards = $state([]);
  let activeArtboard = $state(undefined);
  onMount(() => {
    allArtboards = Array.from(aiBox.querySelectorAll('.g-artboard'));
    onAiMounted();
  });
  $effect(() => {
    if (aiBoxWidth) {
      const currentArtboard = allArtboards.filter((artboard) => {
        const minWidth = parseFloat(artboard.dataset.minWidth);
        const maxWidth = parseFloat(artboard.dataset.maxWidth) || Infinity;
        return minWidth <= aiBoxWidth && maxWidth >= aiBoxWidth;
      })[0];
      if (currentArtboard?.id !== activeArtboard?.id) {
        activeArtboard = untrack(() => currentArtboard);
        onArtboardChange(activeArtboard);
      }
    }
  });
</script>

<div
  id="g-post19-pipelines-box"
  class="ai2svelte"
  bind:this={aiBox}
  bind:clientWidth={aiBoxWidth}
>
  <!-- Artboard: xs -->
  <div
    id="g-post19-pipelines-xs"
    class="g-artboard"
    style="max-width: 509px;aspect-ratio: 0.75111604244742;"
    data-aspect-ratio="0.751"
    data-min-width="0"
    data-max-width="509"
  >
    <div
      id="g-post19-pipelines-xs-img"
      class="g-post19-pipelines-xs-img g-aiImg"
      alt=""
      style="background-image: url({assetsPath.replace(
        new RegExp('/([^/.]+)$'),
        '/$1/'
      ) || '/'}images/graphics/post19-pipelines-xs.jpg);"
    ></div>
    <div
      id="g-ai0-5"
      class="g-text g-aiAbs g-aiPointText"
      style="top:28.9439%;margin-top:-8.2px;left:69.363%;margin-left:-36.5px;width:73px;"
    >
      <p class="g-pstyle4">Iran</p>
    </div>
    <div
      id="g-ai0-7"
      class="g-text g-aiAbs g-aiPointText"
      style="top:50.0929%;margin-top:-8.1px;left:44.2491%;margin-left:-35px;width:70px;"
    >
      <p class="g-pstyle6">The Gulf</p>
    </div>
    <div
      id="g-ai0-16"
      class="g-text g-aiAbs g-aiPointText"
      style="top:95.3874%;margin-top:-8.1px;left:9.7745%;margin-left:-31px;width:62px;"
    >
      <p class="g-pstyle10">100km</p>
    </div>
    <div
      id="g-ai0-3"
      class="g-whiteshadow g-aiAbs g-aiPointText"
      style="top:9.1229%;margin-top:-4.1px;right:29.8303%;width:90px;"
    >
      <p class="g-pstyle2">Iran attacks</p>
    </div>
    <div
      id="g-ai0-6"
      class="g-whiteshadow g-aiAbs g-aiPointText"
      style="top:36.1897%;margin-top:-8px;left:9.583%;margin-left:-32px;width:64px;"
    >
      <p class="g-pstyle5">KUWAIT</p>
    </div>
    <div
      id="g-ai0-2"
      class="g-whiteshadow g-aiAbs g-aiPointText"
      style="top:9.1229%;margin-top:-4.1px;left:6.0344%;width:123px;"
    >
      <p class="g-pstyle1">US/Israel attacks</p>
    </div>
    <div
      id="g-ai0-8"
      class="g-whiteshadow g-aiAbs g-aiPointText"
      style="top:56.134%;margin-top:-16.6px;left:5.2623%;width:87px;"
    >
      <p class="g-pstyle7">East-West</p>
      <p class="g-pstyle7">pipeline</p>
    </div>
    <div
      id="g-ai0-9"
      class="g-whiteshadow g-aiAbs g-aiPointText"
      style="top:54.6262%;margin-top:-8px;left:37.0672%;margin-left:-35.5px;width:71px;"
    >
      <p class="g-pstyle5">Bahrain</p>
    </div>
    <div
      id="g-ai0-10"
      class="g-whiteshadow g-aiAbs g-aiPointText"
      style="top:59.1973%;margin-top:-8.1px;left:49.9222%;width:120px;"
    >
      <p class="g-pstyle8">Strait of Hormuz</p>
    </div>
    <div
      id="g-ai0-11"
      class="g-whiteshadow g-aiAbs g-aiPointText"
      style="top:62.3649%;margin-top:-8px;left:46.6683%;margin-left:-29px;width:58px;"
    >
      <p class="g-pstyle5">Qatar</p>
    </div>
    <div
      id="g-ai0-12"
      class="g-whiteshadow g-aiAbs g-aiPointText"
      style="top:71.8108%;margin-top:-15.5px;left:31.1433%;margin-left:-31.5px;width:63px;"
    >
      <p class="g-pstyle5">Saudi</p>
      <p class="g-pstyle5">Arabia</p>
    </div>
    <div
      id="g-ai0-13"
      class="g-whiteshadow g-aiAbs g-aiPointText"
      style="top:74.4472%;margin-top:-8.1px;left:91.3571%;margin-left:-30.5px;width:61px;"
    >
      <p class="g-pstyle9">Oman</p>
    </div>
    <div
      id="g-ai0-14"
      class="g-whiteshadow g-aiAbs g-aiPointText"
      style="top:75.5664%;margin-top:-8px;left:58.5787%;margin-left:-22px;width:44px;"
    >
      <p class="g-pstyle5">UAE</p>
    </div>
    <div
      id="g-ai0-15"
      class="g-whiteshadow g-aiAbs g-aiPointText"
      style="top:83.4473%;margin-top:-16.6px;left:57.8986%;width:138px;"
    >
      <p class="g-pstyle7">Habshan-Fujairah</p>
      <p class="g-pstyle7">pipeline</p>
    </div>
    <div
      id="g-ai0-4"
      class="g-whiteshadow g-aiAbs g-aiPointText"
      style="top:17.9997%;margin-top:-8.1px;left:62.58%;width:75px;"
    >
      <p class="g-pstyle3">Pipelines</p>
    </div>
    <div
      id="g-ai0-1"
      class="g-whiteshadow g-aiAbs g-aiPointText"
      style="top:3.9067%;margin-top:-8.2px;left:0.204%;width:304px;"
    >
      <p class="g-pstyle0">Pipelines bypassing the Strait of Hormuz</p>
    </div>
  </div>
  <!-- Artboard: sm -->
  <div
    id="g-post19-pipelines-sm"
    class="g-artboard"
    style="min-width: 510px;max-width: 659px;aspect-ratio: 1.00380175705175;"
    data-aspect-ratio="1.004"
    data-min-width="510"
    data-max-width="659"
  >
    <div
      id="g-post19-pipelines-sm-img"
      class="g-post19-pipelines-sm-img g-aiImg"
      alt=""
      style="background-image: url({assetsPath.replace(
        new RegExp('/([^/.]+)$'),
        '/$1/'
      ) || '/'}images/graphics/post19-pipelines-sm.jpg);"
    ></div>
    <div
      id="g-ai1-5"
      class="g-text g-aiAbs g-aiPointText"
      style="top:28.4652%;margin-top:-8.6px;left:65.6646%;margin-left:-35px;width:70px;"
    >
      <p class="g-pstyle4">Iran</p>
    </div>
    <div
      id="g-ai1-7"
      class="g-text g-aiAbs g-aiPointText"
      style="top:43.4238%;margin-top:-8.6px;left:35.2985%;margin-left:-37px;width:74px;"
    >
      <p class="g-pstyle6">The Gulf</p>
    </div>
    <div
      id="g-ai1-16"
      class="g-text g-aiAbs g-aiPointText"
      style="top:95.5739%;margin-top:-9.6px;left:6.4102%;margin-left:-31px;width:62px;"
    >
      <p class="g-pstyle9">100km</p>
    </div>
    <div
      id="g-ai1-3"
      class="g-whiteshadow g-aiAbs g-aiPointText"
      style="top:7.8889%;margin-top:-4.1px;right:54.401%;width:90px;"
    >
      <p class="g-pstyle2">Iran attacks</p>
    </div>
    <div
      id="g-ai1-6"
      class="g-whiteshadow g-aiAbs g-aiPointText"
      style="top:35.354%;margin-top:-8.6px;left:22.8765%;margin-left:-37px;width:74px;"
    >
      <p class="g-pstyle5">KUWAIT</p>
    </div>
    <div
      id="g-ai1-2"
      class="g-whiteshadow g-aiAbs g-aiPointText"
      style="top:7.8889%;margin-top:-4.1px;left:3.7075%;width:123px;"
    >
      <p class="g-pstyle1">US/Israel attacks</p>
    </div>
    <div
      id="g-ai1-8"
      class="g-whiteshadow g-aiAbs g-aiPointText"
      style="top:55.43%;margin-top:-8.6px;left:40.0465%;margin-left:-42px;width:84px;"
    >
      <p class="g-pstyle5">Bahrain</p>
    </div>
    <div
      id="g-ai1-9"
      class="g-whiteshadow g-aiAbs g-aiPointText"
      style="top:61.1542%;margin-top:-16.7px;left:7.5117%;width:96px;"
    >
      <p class="g-pstyle7">East-West</p>
      <p class="g-pstyle7">pipeline</p>
    </div>
    <div
      id="g-ai1-10"
      class="g-whiteshadow g-aiAbs g-aiPointText"
      style="top:60.3506%;margin-top:-8.6px;left:50.1915%;width:127px;"
    >
      <p class="g-pstyle8">Strait of Hormuz</p>
    </div>
    <div
      id="g-ai1-11"
      class="g-whiteshadow g-aiAbs g-aiPointText"
      style="top:63.8935%;margin-top:-8.6px;left:45.8239%;margin-left:-33.5px;width:67px;"
    >
      <p class="g-pstyle5">Qatar</p>
    </div>
    <div
      id="g-ai1-12"
      class="g-whiteshadow g-aiAbs g-aiPointText"
      style="top:73.341%;margin-top:-16.6px;left:35.2417%;margin-left:-36.5px;width:73px;"
    >
      <p class="g-pstyle5">Saudi</p>
      <p class="g-pstyle5">Arabia</p>
    </div>
    <div
      id="g-ai1-13"
      class="g-whiteshadow g-aiAbs g-aiPointText"
      style="top:77.868%;margin-top:-8.6px;left:57.1211%;margin-left:-25px;width:50px;"
    >
      <p class="g-pstyle5">UAE</p>
    </div>
    <div
      id="g-ai1-14"
      class="g-whiteshadow g-aiAbs g-aiPointText"
      style="top:82.608%;margin-top:-16.7px;left:62.2507%;width:154px;"
    >
      <p class="g-pstyle7">Habshan-Fujairah</p>
      <p class="g-pstyle7">pipeline</p>
    </div>
    <div
      id="g-ai1-15"
      class="g-whiteshadow g-aiAbs g-aiPointText"
      style="top:94.4012%;margin-top:-8.6px;left:85.6627%;margin-left:-32px;width:64px;"
    >
      <p class="g-pstyle5">Oman</p>
    </div>
    <div
      id="g-ai1-4"
      class="g-whiteshadow g-aiAbs g-aiPointText"
      style="top:16.6557%;margin-top:-8.6px;left:60.2524%;width:79px;"
    >
      <p class="g-pstyle3">Pipelines</p>
    </div>
    <div
      id="g-ai1-1"
      class="g-whiteshadow g-aiAbs g-aiPointText"
      style="top:3.3783%;margin-top:-8.2px;left:0.3271%;width:304px;"
    >
      <p class="g-pstyle0">Pipelines bypassing the Strait of Hormuz</p>
    </div>
  </div>
  <!-- Artboard: md -->
  <div
    id="g-post19-pipelines-md"
    class="g-artboard"
    style="min-width: 660px;max-width: 929px;aspect-ratio: 1.1655139459782;"
    data-aspect-ratio="1.166"
    data-min-width="660"
    data-max-width="929"
  >
    <div
      id="g-post19-pipelines-md-img"
      class="g-post19-pipelines-md-img g-aiImg"
      alt=""
      style="background-image: url({assetsPath.replace(
        new RegExp('/([^/.]+)$'),
        '/$1/'
      ) || '/'}images/graphics/post19-pipelines-md.jpg);"
    ></div>
    <div
      id="g-ai2-14"
      class="g-text g-aiAbs g-aiPointText"
      style="top:69.0768%;margin-top:-7.2px;left:101.0581%;margin-left:-54.5px;width:109px;"
    >
      <p class="g-pstyle7">Gulf of Oman</p>
    </div>
    <div
      id="g-ai2-8"
      class="g-text g-aiAbs g-aiPointText"
      style="top:31.6391%;margin-top:-7.2px;left:34.6017%;margin-left:-38.5px;width:77px;"
    >
      <p class="g-pstyle7">The Gulf</p>
    </div>
    <div
      id="g-ai2-7"
      class="g-text g-aiAbs g-aiPointText"
      style="top:31.3742%;margin-top:-7.7px;left:-1.2516%;width:137px;"
    >
      <p class="g-pstyle6">Oil and gas fields</p>
    </div>
    <div
      id="g-ai2-19"
      class="g-text g-aiAbs g-aiPointText"
      style="top:95.9926%;margin-top:-8.6px;left:6.5761%;margin-left:-31px;width:62px;"
    >
      <p class="g-pstyle12">100km</p>
    </div>
    <div
      id="g-ai2-1"
      class="g-text g-aiAbs g-aiPointText"
      style="top:8.3435%;margin-top:-7.2px;left:70.2242%;margin-left:-39.5px;width:79px;"
    >
      <p class="g-pstyle0">Iran</p>
    </div>
    <div
      id="g-ai2-5"
      class="g-whiteshadow g-aiAbs g-aiPointText"
      style="top:21.1245%;margin-top:-8.6px;left:13.1627%;margin-left:-37px;width:74px;"
    >
      <p class="g-pstyle4">KUWAIT</p>
    </div>
    <div
      id="g-ai2-4"
      class="g-whiteshadow g-aiAbs g-aiPointText"
      style="top:18.3946%;margin-top:-7.2px;left:74.4151%;margin-left:-68.5px;width:137px;"
    >
      <p class="g-pstyle3">US/Israel attacks</p>
    </div>
    <div
      id="g-ai2-9"
      class="g-whiteshadow g-aiAbs g-aiPointText"
      style="top:47.4515%;margin-top:-19.7px;left:2.4041%;width:171px;"
    >
      <p class="g-pstyle8">Pipelines bypassing</p>
      <p class="g-pstyle8">the Strait of Hormuz</p>
    </div>
    <div
      id="g-ai2-10"
      class="g-whiteshadow g-aiAbs g-aiPointText"
      style="top:48.835%;margin-top:-8.5px;left:37.0762%;margin-left:-38px;width:76px;"
    >
      <p class="g-pstyle9">Bahrain</p>
    </div>
    <div
      id="g-ai2-11"
      class="g-whiteshadow g-aiAbs g-aiPointText"
      style="top:51.3365%;margin-top:-8.7px;left:68.4956%;width:141px;"
    >
      <p class="g-pstyle10">Strait of Hormuz</p>
    </div>
    <div
      id="g-ai2-12"
      class="g-whiteshadow g-aiAbs g-aiPointText"
      style="top:56.1855%;margin-top:-9.2px;left:2.4041%;width:150px;"
    >
      <p class="g-pstyle11">East-West pipeline</p>
    </div>
    <div
      id="g-ai2-13"
      class="g-whiteshadow g-aiAbs g-aiPointText"
      style="top:59.7984%;margin-top:-8.6px;left:45.7224%;margin-left:-33.5px;width:67px;"
    >
      <p class="g-pstyle4">Qatar</p>
    </div>
    <div
      id="g-ai2-3"
      class="g-whiteshadow g-aiAbs g-aiPointText"
      style="top:17.1585%;margin-top:-7.2px;right:63.3913%;width:104px;"
    >
      <p class="g-pstyle2">Kharg Island</p>
    </div>
    <div
      id="g-ai2-15"
      class="g-whiteshadow g-aiAbs g-aiPointText"
      style="top:74.8088%;margin-top:-16.6px;left:33.5594%;margin-left:-36.5px;width:73px;"
    >
      <p class="g-pstyle4">Saudi</p>
      <p class="g-pstyle4">Arabia</p>
    </div>
    <div
      id="g-ai2-16"
      class="g-whiteshadow g-aiAbs g-aiPointText"
      style="top:78.8704%;margin-top:-8.6px;left:92.1143%;margin-left:-32px;width:64px;"
    >
      <p class="g-pstyle4">Oman</p>
    </div>
    <div
      id="g-ai2-17"
      class="g-whiteshadow g-aiAbs g-aiPointText"
      style="top:80.2832%;margin-top:-8.6px;left:60.5003%;margin-left:-25px;width:50px;"
    >
      <p class="g-pstyle4">UAE</p>
    </div>
    <div
      id="g-ai2-18"
      class="g-whiteshadow g-aiAbs g-aiPointText"
      style="top:83.2925%;margin-top:-17.7px;left:69.8938%;width:146px;"
    >
      <p class="g-pstyle11">Habshan-Fujairah</p>
      <p class="g-pstyle11">pipeline</p>
    </div>
    <div
      id="g-ai2-2"
      class="g-whiteshadow g-aiAbs g-aiPointText"
      style="top:11.1543%;margin-top:-7.2px;right:85.6402%;width:100px;"
    >
      <p class="g-pstyle1">Iran attacks</p>
    </div>
    <div
      id="g-ai2-6"
      class="g-whiteshadow g-aiAbs g-aiPointText"
      style="top:29.8731%;margin-top:-7.2px;left:64.1045%;width:83px;"
    >
      <p class="g-pstyle5">Pipelines</p>
    </div>
  </div>
  <!-- Artboard: lg -->
  <div
    id="g-post19-pipelines-lg"
    class="g-artboard"
    style="min-width: 930px;max-width: 1199px;aspect-ratio: 1.64678004835187;"
    data-aspect-ratio="1.647"
    data-min-width="930"
    data-max-width="1199"
  >
    <div
      id="g-post19-pipelines-lg-img"
      class="g-post19-pipelines-lg-img g-aiImg"
      alt=""
      style="background-image: url({assetsPath.replace(
        new RegExp('/([^/.]+)$'),
        '/$1/'
      ) || '/'}images/graphics/post19-pipelines-lg.jpg);"
    ></div>
    <div
      id="g-ai3-8"
      class="g-text g-aiAbs g-aiPointText"
      style="top:31.0242%;margin-top:-7.2px;left:33.2848%;margin-left:-40.5px;width:81px;"
    >
      <p class="g-pstyle7">The Gulf</p>
    </div>
    <div
      id="g-ai3-7"
      class="g-text g-aiAbs g-aiPointText"
      style="top:30.9283%;margin-top:-7.7px;left:7.807%;width:137px;"
    >
      <p class="g-pstyle6">Oil and gas fields</p>
    </div>
    <div
      id="g-ai3-5"
      class="g-text g-aiAbs g-aiPointText"
      style="top:23.5944%;margin-top:-7.2px;left:76.4951%;margin-left:-39.5px;width:79px;"
    >
      <p class="g-pstyle4">Iran</p>
    </div>
    <div
      id="g-ai3-15"
      class="g-text g-aiAbs g-aiPointText"
      style="top:75.2924%;margin-top:-7.2px;left:93.1461%;margin-left:-57px;width:114px;"
    >
      <p class="g-pstyle7">Gulf of Oman</p>
    </div>
    <div
      id="g-ai3-19"
      class="g-text g-aiAbs g-aiPointText"
      style="top:95.5453%;margin-top:-8.6px;left:4.6661%;margin-left:-31px;width:62px;"
    >
      <p class="g-pstyle12">100km</p>
    </div>
    <div
      id="g-ai3-4"
      class="g-whiteshadow g-aiAbs g-aiPointText"
      style="top:20.6507%;margin-top:-8.6px;left:18.0367%;margin-left:-37px;width:74px;"
    >
      <p class="g-pstyle3">KUWAIT</p>
    </div>
    <div
      id="g-ai3-3"
      class="g-whiteshadow g-aiAbs g-aiPointText"
      style="top:17.9134%;margin-top:-7.2px;left:61.5061%;margin-left:-68.5px;width:137px;"
    >
      <p class="g-pstyle2">US/Israel attacks</p>
    </div>
    <div
      id="g-ai3-9"
      class="g-whiteshadow g-aiAbs g-aiPointText"
      style="top:41.7371%;margin-top:-8.7px;left:81.7286%;width:141px;"
    >
      <p class="g-pstyle8">Strait of Hormuz</p>
    </div>
    <div
      id="g-ai3-10"
      class="g-whiteshadow g-aiAbs g-aiPointText"
      style="top:47.7723%;margin-top:-18.8px;left:3.8864%;width:189px;"
    >
      <p class="g-pstyle9">Pipelines bypassing</p>
      <p class="g-pstyle9">the Strait of Hormuz</p>
    </div>
    <div
      id="g-ai3-11"
      class="g-whiteshadow g-aiAbs g-aiPointText"
      style="top:48.4365%;margin-top:-8.5px;left:35.0076%;margin-left:-38px;width:76px;"
    >
      <p class="g-pstyle10">Bahrain</p>
    </div>
    <div
      id="g-ai3-12"
      class="g-whiteshadow g-aiAbs g-aiPointText"
      style="top:56.6112%;margin-top:-9.7px;left:3.8864%;width:158px;"
    >
      <p class="g-pstyle11">East-West pipeline</p>
    </div>
    <div
      id="g-ai3-13"
      class="g-whiteshadow g-aiAbs g-aiPointText"
      style="top:59.4297%;margin-top:-8.6px;left:41.1435%;margin-left:-33.5px;width:67px;"
    >
      <p class="g-pstyle3">Qatar</p>
    </div>
    <div
      id="g-ai3-14"
      class="g-whiteshadow g-aiAbs g-aiPointText"
      style="top:72.8873%;margin-top:-16.6px;left:32.7972%;margin-left:-36.5px;width:73px;"
    >
      <p class="g-pstyle3">Saudi</p>
      <p class="g-pstyle3">Arabia</p>
    </div>
    <div
      id="g-ai3-2"
      class="g-whiteshadow g-aiAbs g-aiPointText"
      style="top:16.6739%;margin-top:-7.2px;right:65.3243%;width:104px;"
    >
      <p class="g-pstyle1">Kharg Island</p>
    </div>
    <div
      id="g-ai3-16"
      class="g-whiteshadow g-aiAbs g-aiPointText"
      style="top:78.5536%;margin-top:-8.6px;left:74.0668%;margin-left:-32px;width:64px;"
    >
      <p class="g-pstyle3">Oman</p>
    </div>
    <div
      id="g-ai3-17"
      class="g-whiteshadow g-aiAbs g-aiPointText"
      style="top:79.9702%;margin-top:-8.6px;left:51.6311%;margin-left:-25px;width:50px;"
    >
      <p class="g-pstyle3">UAE</p>
    </div>
    <div
      id="g-ai3-18"
      class="g-whiteshadow g-aiAbs g-aiPointText"
      style="top:83.1722%;margin-top:-18.7px;left:58.2974%;width:154px;"
    >
      <p class="g-pstyle11">Habshan-Fujairah</p>
      <p class="g-pstyle11">pipeline</p>
    </div>
    <div
      id="g-ai3-6"
      class="g-whiteshadow g-aiAbs g-aiPointText"
      style="top:29.4231%;margin-top:-7.2px;left:53.8443%;width:83px;"
    >
      <p class="g-pstyle5">Pipelines</p>
    </div>
    <div
      id="g-ai3-1"
      class="g-whiteshadow g-aiAbs g-aiPointText"
      style="top:12.7783%;margin-top:-7.2px;right:86.1433%;width:100px;"
    >
      <p class="g-pstyle0">Iran attacks</p>
    </div>
  </div>
  <!-- Artboard: xl -->
  <div
    id="g-post19-pipelines-xl"
    class="g-artboard"
    style="min-width: 1200px;aspect-ratio: 1.93548387096774;"
    data-aspect-ratio="1.935"
    data-min-width="1200"
  >
    <div
      id="g-post19-pipelines-xl-img"
      class="g-post19-pipelines-xl-img g-aiImg"
      alt=""
      style="background-image: url({assetsPath.replace(
        new RegExp('/([^/.]+)$'),
        '/$1/'
      ) || '/'}images/graphics/post19-pipelines-xl.jpg);"
    ></div>
    <div
      id="g-ai4-2"
      class="g-text g-aiAbs g-aiPointText"
      style="top:50.0937%;margin-top:-9.6px;left:42.55%;width:194px;"
    >
      <p class="g-pstyle1">Secondary annotation @14px</p>
    </div>
    <div
      id="g-ai4-3"
      class="g-text g-aiAbs g-aiPointText"
      style="top:55.2416%;margin-top:-9.5px;left:42.55%;width:154px;"
    >
      <p class="g-pstyle2">Tertiary annotation @12px</p>
    </div>
    <div
      id="g-ai4-1"
      class="g-text g-aiAbs g-aiPointText"
      style="top:45.1071%;margin-top:-9.7px;left:42.55%;width:201px;"
    >
      <p class="g-pstyle0">Primary annotation @16px</p>
    </div>
  </div>
</div>

<!-- End ai2svelte - 2026-03-17 16:42 -->

<!-- Generated by ai2svelte v1.0.3 - 2026-03-17 16:42 -->
<!-- ai file: post19-pipelines.ai -->
<style lang="scss">
  #g-post19-pipelines-box {
    container-type: inline-size;
    container-name: g-post19-pipelines-box;
  }
  #g-post19-pipelines-box,
  #g-post19-pipelines-box .g-artboard {
    margin: 0 auto;
  }
  #g-post19-pipelines-box p {
    margin: 0;
  }
  #g-post19-pipelines-box .g-aiAbs {
    position: absolute;
  }
  #g-post19-pipelines-box .g-aiImg {
    position: absolute;
    top: 0;
    display: block;
    width: 100% !important;
    height: 100%;
    background-size: contain;
    background-repeat: no-repeat;
  }
  #g-post19-pipelines-box .g-aiSymbol {
    position: absolute;
    box-sizing: border-box;
  }
  #g-post19-pipelines-box .g-aiPointText p {
    white-space: nowrap;
  }
  #g-post19-pipelines-box.g-aiPointText p {
    white-space: nowrap;
  }
  #g-post19-pipelines-box {
    width: 100%;
    container-type: inline-size;
    @container (min-width:0px) and (max-width: 509px) {
      #g-post19-pipelines-xs {
        display: block !important;
      }
    }
    @container (min-width:510px) and (max-width: 659px) {
      #g-post19-pipelines-sm {
        display: block !important;
      }
    }
    @container (min-width:660px) and (max-width: 929px) {
      #g-post19-pipelines-md {
        display: block !important;
      }
    }
    @container (min-width:930px) and (max-width: 1199px) {
      #g-post19-pipelines-lg {
        display: block !important;
      }
    }
    @container (min-width:1200px) {
      #g-post19-pipelines-xl {
        display: block !important;
      }
    }
  }
  #g-post19-pipelines-xs {
    position: relative;
    overflow: hidden;
    display: none;
  }
  #g-post19-pipelines-xs p {
    font-family: var(--theme-font-family-sans-serif), Knowledge, sans-serif;
    font-weight: regular;
    line-height: 16px;
    height: auto;
    opacity: 1;
    letter-spacing: 0em;
    font-size: 15px;
    text-align: left;
    color: rgb(64, 64, 64);
    text-transform: none;
    padding-bottom: 0;
    padding-top: 0;
    mix-blend-mode: normal;
    font-style: normal;
    position: static;
  }
  #g-post19-pipelines-xs .g-pstyle0 {
    font-weight: 700;
    line-height: 15px;
    height: 15px;
    font-size: 16px;
  }
  #g-post19-pipelines-xs .g-pstyle1 {
    font-weight: 400;
    line-height: 7px;
    height: 7px;
    font-size: 14px;
    color: rgb(8, 81, 156);
  }
  #g-post19-pipelines-xs .g-pstyle2 {
    font-weight: 400;
    line-height: 7px;
    height: 7px;
    font-size: 14px;
    text-align: right;
    color: rgb(176, 42, 41);
  }
  #g-post19-pipelines-xs .g-pstyle3 {
    font-weight: 400;
    line-height: 15px;
    height: 15px;
    font-size: 14px;
  }
  #g-post19-pipelines-xs .g-pstyle4 {
    font-weight: 900;
    line-height: 15px;
    height: 15px;
    letter-spacing: 0.27em;
    font-size: 16px;
    text-align: center;
    text-transform: uppercase;
  }
  #g-post19-pipelines-xs .g-pstyle5 {
    font-weight: 400;
    line-height: 15px;
    height: 15px;
    font-size: 12px;
    text-align: center;
    text-transform: uppercase;
    color: rgb(151, 151, 151);
  }
  #g-post19-pipelines-xs .g-pstyle6 {
    font-weight: 400;
    font-style: italic;
    line-height: 15px;
    height: 15px;
    font-size: 14px;
    text-align: center;
    color: rgb(94, 154, 220);
  }
  #g-post19-pipelines-xs .g-pstyle7 {
    font-weight: 500;
    height: 16px;
  }
  #g-post19-pipelines-xs .g-pstyle8 {
    font-weight: 700;
    font-style: italic;
    line-height: 15px;
    height: 15px;
    font-size: 14px;
    color: rgb(94, 154, 220);
  }
  #g-post19-pipelines-xs .g-pstyle9 {
    font-weight: 400;
    line-height: 15px;
    height: 15px;
    font-size: 14px;
    text-align: center;
    text-transform: uppercase;
    color: rgb(151, 151, 151);
  }
  #g-post19-pipelines-xs .g-pstyle10 {
    font-weight: 400;
    line-height: 15px;
    height: 15px;
    font-size: 14px;
    text-align: center;
    color: rgb(152, 152, 152);
  }
  #g-post19-pipelines-sm {
    position: relative;
    overflow: hidden;
    display: none;
  }
  #g-post19-pipelines-sm p {
    font-family: var(--theme-font-family-sans-serif), Knowledge, sans-serif;
    font-weight: regular;
    line-height: 16px;
    height: auto;
    opacity: 1;
    letter-spacing: 0em;
    font-size: 17px;
    text-align: left;
    color: rgb(64, 64, 64);
    text-transform: none;
    padding-bottom: 0;
    padding-top: 0;
    mix-blend-mode: normal;
    font-style: normal;
    position: static;
  }
  #g-post19-pipelines-sm .g-pstyle0 {
    font-weight: 700;
    line-height: 15px;
    height: 15px;
    font-size: 16px;
  }
  #g-post19-pipelines-sm .g-pstyle1 {
    font-weight: 400;
    line-height: 7px;
    height: 7px;
    font-size: 14px;
    color: rgb(8, 81, 156);
  }
  #g-post19-pipelines-sm .g-pstyle2 {
    font-weight: 400;
    line-height: 7px;
    height: 7px;
    font-size: 14px;
    text-align: right;
    color: rgb(176, 42, 41);
  }
  #g-post19-pipelines-sm .g-pstyle3 {
    font-weight: 400;
    height: 16px;
    font-size: 15px;
  }
  #g-post19-pipelines-sm .g-pstyle4 {
    font-weight: 900;
    height: 16px;
    letter-spacing: 0.27em;
    font-size: 15px;
    text-align: center;
    text-transform: uppercase;
  }
  #g-post19-pipelines-sm .g-pstyle5 {
    font-weight: 400;
    height: 16px;
    font-size: 15px;
    text-align: center;
    text-transform: uppercase;
    color: rgb(151, 151, 151);
  }
  #g-post19-pipelines-sm .g-pstyle6 {
    font-weight: 400;
    font-style: italic;
    height: 16px;
    font-size: 15px;
    text-align: center;
    color: rgb(94, 154, 220);
  }
  #g-post19-pipelines-sm .g-pstyle7 {
    font-weight: 500;
    height: 16px;
  }
  #g-post19-pipelines-sm .g-pstyle8 {
    font-weight: 700;
    font-style: italic;
    height: 16px;
    font-size: 15px;
    color: rgb(94, 154, 220);
  }
  #g-post19-pipelines-sm .g-pstyle9 {
    font-weight: 400;
    line-height: 18px;
    height: 18px;
    font-size: 14px;
    text-align: center;
    color: rgb(152, 152, 152);
  }
  #g-post19-pipelines-md {
    position: relative;
    overflow: hidden;
    display: none;
  }
  #g-post19-pipelines-md p {
    font-family: var(--theme-font-family-sans-serif), Knowledge, sans-serif;
    font-weight: regular;
    line-height: 17px;
    height: auto;
    opacity: 1;
    letter-spacing: 0em;
    font-size: 16px;
    text-align: left;
    color: rgb(64, 64, 64);
    text-transform: none;
    padding-bottom: 0;
    padding-top: 0;
    mix-blend-mode: normal;
    font-style: normal;
    position: static;
  }
  #g-post19-pipelines-md .g-pstyle0 {
    font-weight: 900;
    line-height: 13px;
    height: 13px;
    letter-spacing: 0.27em;
    font-size: 18px;
    text-align: center;
    text-transform: uppercase;
  }
  #g-post19-pipelines-md .g-pstyle1 {
    font-weight: 400;
    line-height: 13px;
    height: 13px;
    text-align: right;
    color: rgb(176, 42, 41);
  }
  #g-post19-pipelines-md .g-pstyle2 {
    font-weight: 300;
    line-height: 13px;
    height: 13px;
    text-align: right;
  }
  #g-post19-pipelines-md .g-pstyle3 {
    font-weight: 400;
    line-height: 13px;
    height: 13px;
    text-align: center;
    color: rgb(8, 81, 156);
  }
  #g-post19-pipelines-md .g-pstyle4 {
    font-weight: 400;
    line-height: 16px;
    height: 16px;
    font-size: 15px;
    text-align: center;
    text-transform: uppercase;
    color: rgb(151, 151, 151);
  }
  #g-post19-pipelines-md .g-pstyle5 {
    font-weight: 400;
    line-height: 13px;
    height: 13px;
  }
  #g-post19-pipelines-md .g-pstyle6 {
    font-weight: 400;
    line-height: 14px;
    height: 14px;
    padding-bottom: 7px;
    color: rgb(151, 151, 151);
  }
  #g-post19-pipelines-md .g-pstyle7 {
    font-weight: 400;
    font-style: italic;
    line-height: 13px;
    height: 13px;
    text-align: center;
    color: rgb(94, 154, 220);
  }
  #g-post19-pipelines-md .g-pstyle8 {
    font-weight: 700;
    line-height: 19px;
    height: 19px;
    font-size: 17px;
  }
  #g-post19-pipelines-md .g-pstyle9 {
    font-weight: 400;
    line-height: 16px;
    height: 16px;
    font-size: 13px;
    text-align: center;
    text-transform: uppercase;
    color: rgb(151, 151, 151);
  }
  #g-post19-pipelines-md .g-pstyle10 {
    font-weight: 700;
    font-style: italic;
    line-height: 16px;
    height: 16px;
    font-size: 17px;
  }
  #g-post19-pipelines-md .g-pstyle11 {
    font-weight: 500;
    height: 17px;
  }
  #g-post19-pipelines-md .g-pstyle12 {
    font-weight: 400;
    line-height: 16px;
    height: 16px;
    font-size: 14px;
    text-align: center;
    color: rgb(152, 152, 152);
  }
  #g-post19-pipelines-lg {
    position: relative;
    overflow: hidden;
    display: none;
  }
  #g-post19-pipelines-lg p {
    font-family: var(--theme-font-family-sans-serif), Knowledge, sans-serif;
    font-weight: regular;
    line-height: 18px;
    height: auto;
    opacity: 1;
    letter-spacing: 0em;
    font-size: 17px;
    text-align: left;
    color: rgb(64, 64, 64);
    text-transform: none;
    padding-bottom: 0;
    padding-top: 0;
    mix-blend-mode: normal;
    font-style: normal;
    position: static;
  }
  #g-post19-pipelines-lg .g-pstyle0 {
    font-weight: 400;
    line-height: 13px;
    height: 13px;
    font-size: 16px;
    text-align: right;
    color: rgb(176, 42, 41);
  }
  #g-post19-pipelines-lg .g-pstyle1 {
    font-weight: 300;
    line-height: 13px;
    height: 13px;
    font-size: 16px;
    text-align: right;
  }
  #g-post19-pipelines-lg .g-pstyle2 {
    font-weight: 400;
    line-height: 13px;
    height: 13px;
    font-size: 16px;
    text-align: center;
    color: rgb(8, 81, 156);
  }
  #g-post19-pipelines-lg .g-pstyle3 {
    font-weight: 400;
    line-height: 16px;
    height: 16px;
    font-size: 15px;
    text-align: center;
    text-transform: uppercase;
    color: rgb(151, 151, 151);
  }
  #g-post19-pipelines-lg .g-pstyle4 {
    font-weight: 900;
    line-height: 13px;
    height: 13px;
    letter-spacing: 0.27em;
    font-size: 18px;
    text-align: center;
    text-transform: uppercase;
  }
  #g-post19-pipelines-lg .g-pstyle5 {
    font-weight: 400;
    line-height: 13px;
    height: 13px;
    font-size: 16px;
  }
  #g-post19-pipelines-lg .g-pstyle6 {
    font-weight: 400;
    line-height: 14px;
    height: 14px;
    padding-bottom: 7px;
    font-size: 16px;
    color: rgb(151, 151, 151);
  }
  #g-post19-pipelines-lg .g-pstyle7 {
    font-weight: 400;
    font-style: italic;
    line-height: 13px;
    height: 13px;
    text-align: center;
    color: rgb(94, 154, 220);
  }
  #g-post19-pipelines-lg .g-pstyle8 {
    font-weight: 700;
    font-style: italic;
    line-height: 16px;
    height: 16px;
  }
  #g-post19-pipelines-lg .g-pstyle9 {
    font-weight: 700;
    height: 18px;
    font-size: 19px;
  }
  #g-post19-pipelines-lg .g-pstyle10 {
    font-weight: 400;
    line-height: 16px;
    height: 16px;
    font-size: 13px;
    text-align: center;
    text-transform: uppercase;
    color: rgb(151, 151, 151);
  }
  #g-post19-pipelines-lg .g-pstyle11 {
    font-weight: 500;
    height: 18px;
  }
  #g-post19-pipelines-lg .g-pstyle12 {
    font-weight: 400;
    line-height: 16px;
    height: 16px;
    font-size: 14px;
    text-align: center;
    color: rgb(152, 152, 152);
  }
  #g-post19-pipelines-xl {
    position: relative;
    overflow: hidden;
    display: none;
  }
  #g-post19-pipelines-xl p {
    font-family: var(--theme-font-family-sans-serif), Knowledge, sans-serif;
    font-weight: regular;
    line-height: 18px;
    height: auto;
    opacity: 1;
    padding-bottom: 0;
    letter-spacing: 0em;
    font-size: 14px;
    text-align: left;
    color: rgb(64, 64, 64);
    text-transform: none;
    padding-top: 0;
    mix-blend-mode: normal;
    font-style: normal;
    position: static;
  }
  #g-post19-pipelines-xl .g-pstyle0 {
    font-weight: 400;
    height: 18px;
    padding-bottom: 9px;
    font-size: 16px;
  }
  #g-post19-pipelines-xl .g-pstyle1 {
    font-weight: 400;
    height: 18px;
    padding-bottom: 9px;
  }
  #g-post19-pipelines-xl .g-pstyle2 {
    font-weight: 400;
    height: 18px;
    padding-bottom: 9px;
    font-size: 12px;
    color: rgb(102, 102, 102);
  }

  /* Custom CSS */
</style>
